import * as React from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';
import type {
  NWTEvent,
  NWTExtendedEvent,
  NWTExperimentEvent,
} from '@xing-com/crate-communication-tracking';

type TrackNetworkNWTProps =
  | NWTEvent
  | {
      event: string;
    };

type TrackNetworkNWT = (props: TrackNetworkNWTProps) => void;

type TrackNetworkNWTExtended = (props: Partial<NWTExtendedEvent>) => void;

type TrackNetworkNWTExperiment = (props: Partial<NWTExperimentEvent>) => void;

type UseNetworkTracking = () => {
  trackNetworkNWT: TrackNetworkNWT;
  trackNetworkNWTExtended: TrackNetworkNWTExtended;
  trackNetworkNWTExperiment: TrackNetworkNWTExperiment;
};

export const useNetworkTracking: UseNetworkTracking = () => {
  const { track } = useTracking();

  const trackNetworkNWT: TrackNetworkNWT = React.useCallback(
    (props) => {
      track({
        type: 'nwt',
        eventSchema: 'basic',
        sentBy: 'network',
        page: 'network/network',
        application: 'wbm',
        ...props,
      });
    },
    [track]
  );

  const trackNetworkNWTExtended: TrackNetworkNWTExtended = React.useCallback(
    (props) => {
      // oxlint-disable-next-line typescript/consistent-type-assertions
      track({
        type: 'nwt',
        eventSchema: 'extended',
        sentBy: 'network',
        page: 'network/network',
        application: 'wbm',
        ...props,
      } as NWTEvent);
    },
    [track]
  );

  const trackNetworkNWTExperiment: TrackNetworkNWTExperiment =
    React.useCallback(
      (props) => {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        track({
          type: 'nwt',
          eventSchema: 'experiment',
          sentBy: 'network',
          event: 'experiment_fetched',
          page: 'network/network',
          application: 'wbm',
          ...props,
        } as NWTEvent);
      },
      [track]
    );

  return {
    trackNetworkNWT,
    trackNetworkNWTExtended,
    trackNetworkNWTExperiment,
  };
};
